import { useQuery } from '@tanstack/react-query';
import UserManagerService from '../services/UserManager/userManager.service';

// Rosters change rarely; without this every wizard open refetches the list.
const GROUPS_STALE_TIME = 5 * 60 * 1000;

export const useOrgGroups = () => {
  const { getGroupsList } = UserManagerService();
  const groupsQuery = useQuery({ ...getGroupsList(), staleTime: GROUPS_STALE_TIME });

  return { groups: groupsQuery.data ?? [], isLoadingGroups: groupsQuery.isLoading };
};
